import type { Scene } from '@/types'

import { VIOLENCIAS } from '@/constants/violencias'

/** §18 — every magic number in one block */
export const VIS = {
    N: 9,
    INITIAL: 0,

    // ring + sizing
    RING_R: 0.34,
    RING_R_PHONE: 0.38,
    RING_CY: 0.055,
    CARD_FACTOR: 0.17,
    CARD_FACTOR_PHONE: 0.21,
    CARD_MIN: 60,
    CARD_MAX: 184,
    BASE_SCALE: 0.86,
    TOP_EMPHASIS: 0.32,
    LIFT: 7,

    // glass
    FACE_INSET: 16,
    BEZEL_RATIO: 0.16,
    THICKNESS: 34,
    CHROMA: 2.2,
    WOBBLE: 0.38,

    // motion (ms)
    ENTER_DELAY: 150,
    ENTER_BG_DUR: 2000,
    ENTER_DUR: 2700,
    ENTER_SPIN: 2.4,
    STEP_DUR: 1000,

    // interaction
    DRAG_PER_STEP: 260,
    WHEEL_THRESHOLD: 88,
    WHEEL_GAP: 140,
    AUTO_TICK: 360,
    AUTO_INTERVAL: 3600,
    USER_IDLE: 4400,

    PHONE: 640
} as const

/**
 * §17 — the nine records, rendered in array order and wrapped infinitely.
 * Each one is a form of violence: the content lives in `@/constants/violencias`
 * and the ring only takes its name, its caption and its scene from there.
 */
export const SCENES: Scene[] = VIOLENCIAS.map(({ slug, nome, legenda, cena }) => ({
    slug,
    title: nome,
    caption: legenda,
    ...cena
}))

export const sceneSrc = (image: string): string => `/visionaries/${image}.jpg`

/** §6 — thumbnail sepia wash per tone */
export const toneSepia = (tone: Scene['tone']): number => {
    if (tone === 'ink') return 0.14
    if (tone === 'photo') return 0.08

    return 0
}
